import { SVGProps } from 'react'

const DirectorsServiceIcon = ({ fill = 'white', ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width || '48'}
      height={props.height || '48'}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        stroke={fill}
        d='M17.1428 25.7143L23.4861 32.2925C23.6197 32.431 23.8492 32.4006 23.942 32.2321L32.5714 16.5714'
        stroke-width='3.42857'
        stroke-linecap='round'
      />
      <path
        stroke={fill}
        d='M42.8035 10.5713C42.8035 14.4424 43.4702 23.2743 40.2224 30.9531V30.9541C38.5672 34.8655 35.9471 38.3593 33.0857 40.8906C30.2775 43.3748 26.9905 45.1426 23.9724 45.1426C21.0825 45.1425 17.9265 43.7315 15.0994 41.3398C12.2442 38.9245 9.59995 35.4116 7.72241 30.9512V30.9502C6.38825 27.7929 5.75868 23.8425 5.44995 20.1836C5.13884 16.4963 5.14331 12.9521 5.14331 10.5713C5.14338 9.66907 5.84271 8.92166 6.74292 8.86133C15.0041 8.30761 19.5993 5.86138 22.7781 2.77051L22.8982 2.66406C23.5218 2.16167 24.4219 2.15574 25.0544 2.66992C29.653 6.4076 34.9847 8.64156 41.1501 8.8584C42.0726 8.89108 42.8034 9.64818 42.8035 10.5713Z'
        stroke-width='3.42857'
        stroke-linejoin='round'
      />
    </svg>
  )
}

export default DirectorsServiceIcon
